module.exports = __webpack_public_path__ + "static/media/ppt.cd1bfbda.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ppt.png
// module id = 238
// module chunks = 0